import React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

import { applyDecorators } from "@app/Helpers/Decorator";
import { EnumModel } from "@app/Models/WebApiModels";
import { Icon } from "../Icon";

type ExplainErrorChatActionButtonProps = {
    iconName: IconName;
    noSolidIcon?: boolean;
    className?: string;
    isDisabled?: boolean;
    title?: string;
    onClick: () => void;
};

export class ExplainErrorChatActionButton extends React.Component<ExplainErrorChatActionButtonProps> {

    constructor(props: ExplainErrorChatActionButtonProps) {
        super(props);
        applyDecorators(this);
    }

    render() {
        const { iconName, noSolidIcon, className, isDisabled, title, onClick } = this.props;
        const classNames = ['chat-interactions-button'];
        if (className) classNames.push(className);

        return (
            <Button className={classNames.join(' ')} disabled={isDisabled} title={title} onClick={onClick}>
                <Icon name={iconName} noSolid={noSolidIcon}/>
            </Button>
        );
    }
}

type ExplainErrorChatActionSelectProps = {
    iconName: IconName;
    className?: string;
    title?: string;
    options: EnumModel[];
    value: string;
    onSelect: (value: string) => void;
};

@observer
export class ExplainErrorChatActionSelect extends React.Component<ExplainErrorChatActionSelectProps> {
    @observable private _isDropdownOpen: boolean = false;

    constructor(props: ExplainErrorChatActionSelectProps) {
        super(props);
        applyDecorators(this);
    }

    render() {
        const { iconName, className, title, options, value, onSelect } = this.props;
        const classNames = ['chat-interactions-select'];
        if (className) classNames.push(className);

        const selectedOptionName = options.find(o => o.code === value)?.name;
        return (
            <Dropdown isOpen={this._isDropdownOpen} toggle={this._onToggleDropdown} title={title} className={classNames.join(' ')}>
                <DropdownToggle caret className="chat-interactions-button">
                    <Icon name={iconName} />
                    <span className="chat-interactions-select-value">{selectedOptionName}</span>
                </DropdownToggle>
                <DropdownMenu>
                    {options.map(o => {
                        return (
                            <DropdownItem
                                key={o.code}
                                active={value === o.code}
                                onClick={() => onSelect(o.code)}
                            >
                                {o.name}
                            </DropdownItem>
                        );
                    })}
                </DropdownMenu>
            </Dropdown>
        );
    }

    @action.bound
    private async _onToggleDropdown() {
        this._isDropdownOpen = !this._isDropdownOpen;
    }
}